export enum TransactionType {
  Credit = 1,
  Redemption,
}

export const TransactionTypeLabel = {
  [TransactionType.Credit]: 'Crédito',
  [TransactionType.Redemption]: 'Resgate',
}
